import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { SketchPicker } from 'react-color';

import useStyles from './printStyles';
import Placeholders from './Placeholders';


const TextForm = ({
  textData,
  setText,
  fontFamilies,
  colorRef,
  selectedLayer,
  handleColorChangeComplete,
  handleTextLayerSubmit
}) => {
  const classes = useStyles();

  return (
    <>
      <Box mx={4} pb={2}>
        <Grid container spacing={2}>

          {<Grid item xs={12}>
            <Placeholders text={textData} setText={setText} />
            <TextField
              id="text-form"
              fullWidth
              label="Layer Text"
              variant="outlined"
              multiline
              rows={4}
              value={textData.text}
              onChange={(e) => setText(Object.assign({...textData, text: e.target.value}))} />
          </Grid>}

          <Box display="flex" padding={1}>
            <Box flexGrow={1} pr={2}>
              <FormControl fullWidth className={classes.formControl}>
                <InputLabel id="font-size-label">Font Size (pixels)</InputLabel>
                <Select
                  labelId="font-size-label"
                  id="font-size"
                  value={textData.size}
                  onChange={(e) => setText({...textData, size: e.target.value})}>
                  <MenuItem value="50">50</MenuItem>
                  <MenuItem value="75">75</MenuItem>
                  <MenuItem value="100">100</MenuItem>
                  <MenuItem value="200">200</MenuItem>
                  <MenuItem value="300">300</MenuItem>
                  <MenuItem value="400">400</MenuItem>
                  <MenuItem value="500">500</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth className={classes.formControl}>
                <InputLabel id="font-family-label">Font Family</InputLabel>
                <Select
                  labelId="font-family-label"
                  id="font-family"
                  defaultValue={textData.text}
                  value={textData.fontFamily}
                  onChange={(e) => setText({...textData, fontFamily: e.target.value})}>
                  {fontFamilies.map((font, key) => (
                    <MenuItem key={key}value={font.name}>{font.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth className={classes.formControl}>
                <TextField
                  label="Text Width (pixels)"
                  id="text-width"
                  placeholder="100"
                  defaultValue={textData.width}
                  value={textData.width}
                  onChange={(e) => setText({...textData, width: e.target.value})}>
                </TextField>
              </FormControl>
            </Box>

            <Box>
              <SketchPicker
                color={colorRef?.current}
                disableAlpha
                onChangeComplete={handleColorChangeComplete} />
            </Box>
          </Box>

          <Grid item xs={12}>
            <Button fullWidth variant="contained" color="primary" onClick={handleTextLayerSubmit}>{selectedLayer ? 'Update Text' : 'Add Text'}</Button>
          </Grid>

        </Grid>
      </Box>
    </>
  );
};

export default TextForm;